import { BaseMapAutoZoomService } from '@/modules/ta/legacy/widget/services/types/BaseMapAutoZoomService';

export class BubbleMapAutoZoomService extends BaseMapAutoZoomService {
  constructor(topPercent = 100) {
    super(topPercent);
  }
}
